import type { TextLinkRunMetric } from "../linkPopup/types";
import type { TextLine, TextV2Data } from "../typesV2";
import { getLineStartX, getSegmentWidth, getTextStartX } from "./measurements";

interface BuildLinkRunsArgs {
    uid: string;
    lines: TextLine[];
    lineWidths: number[];
    lineHeight: number;
    horizontalPadding: number;
    data: TextV2Data;
}

export function buildLinkRuns({
    uid,
    lines,
    lineWidths,
    lineHeight,
    horizontalPadding,
    data,
}: BuildLinkRunsArgs): TextLinkRunMetric[][] {
    const runsByLine: TextLinkRunMetric[][] = [];
    let localY = 0;

    lines.forEach((line, lineIndex) => {
        const lineRuns: TextLinkRunMetric[] = [];
        const lineWidth = lineWidths[lineIndex];
        const lineStartX = getLineStartX(lineWidth, 0, data.textAlign);

        let currentX = getTextStartX(line, lineStartX, data, horizontalPadding, lineHeight);

        let activeRun: TextLinkRunMetric | null = null;
        let runIndex = 0;

        for (const segment of line.segments) {
            const width = getSegmentWidth(segment, data);

            if (segment.link) {
                if (activeRun && activeRun.url === segment.link) {
                    activeRun.localRect.width += width;
                    activeRun.localAnchorRect.width += width;
                } else {
                    activeRun = {
                        widgetId: uid,
                        lineIndex,
                        runIndex,
                        url: segment.link,
                        key: `${uid}:${lineIndex}:${runIndex}:${segment.link}`,
                        localRect: {
                            x: currentX,
                            y: localY,
                            width,
                            height: lineHeight,
                        },
                        localAnchorRect: {
                            x: currentX,
                            y: localY,
                            width,
                            height: lineHeight,
                        },
                    };

                    lineRuns.push(activeRun);
                    runIndex += 1;
                }
            } else {
                activeRun = null;
            }

            currentX += width;
        }

        runsByLine[lineIndex] = lineRuns;
        localY += lineHeight;
    });

    return runsByLine;
}
